import { Grid, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const checks = [
  {
    label: 'Quyền và trách nhiệm của bệnh nhân',
    key: 'education_list.checked1',
  },
  {
    label: 'Những gì mang theo theo khi nhập viện',
    key: 'education_list.checked2',
  },
  {
    label:
      'Cơ sở vật chất trong phòng của bạn (đệm, giường ngủ, đèn chiếu sáng, điện thoại, TV, chuông gọi khẩn cấp, chuông gọi điều dưỡng, điều hòa, sưởi ấm, khác',
    key: 'education_list.checked3',
  },
  {
    label: 'Cơ sở vật chất trong đơn vị điều dưỡng',
    key: 'education_list.checked4',
  },
  {
    label: 'Cơ sở vật chất trong bệnh viện',
    key: 'education_list.checked5',
  },
  {
    label: 'Sử dụng điện thoại đầu giường và kết nối internet',
    key: 'education_list.checked6',
  },
  {
    label: 'Gọi y tá yêu cầu hỗ trợ',
    key: 'education_list.checked7',
  },
  {
    label:
      'Phòng chống hỏa hoạn và khói, phải làm gì trong trường hợp hỏa hoạn',
    key: 'education_list.checked8',
  },
  {
    label: 'Phòng ngừa trộm cướp',
    key: 'education_list.checked9',
  },
  {
    label: 'Ngăn ngừa thương tích / té ngã',
    key: 'education_list.checked10',
  },
  {
    label: 'Giờ thăm của khách và giờ ăn ',
    key: 'education_list.checked11',
  },
  {
    label: 'Quyền lựa chọn chuyên gia và trách nhiệm trả phí tư vấn chuyên gia',
    key: 'education_list.checked12',
  },
  {
    label: 'Thời gian khám của bác sĩ',
    key: 'education_list.checked13',
  },
  {
    label:
      'Yêu cầu các tài liệu cần thiết (giấy chứng nhận y tế, hồ sơ điểm danh)',
    key: 'education_list.checked14',
  },
  {
    label: 'Hệ thống báo cáo khiếu nại',
    key: 'education_list.checked15',
  },
  {
    label: 'Yêu cầu người chăm sóc',
    key: 'education_list.checked16',
  },
  {
    label: 'Ra ngoài trong lúc nhập viện',
    key: 'education_list.checked17',
  },
  {
    label: 'Dịch vụ khách hàng',
    key: 'education_list.checked18',
  },
  {
    label: 'Đỗ xe',
    key: 'education_list.checked19',
  },
  {
    label: 'Tiền chi trả trong thời gian giữa kỳ nhập viện',
    key: 'education_list.checked20',
  },
  {
    label: 'Thủ tục xuất viện',
    key: 'education_list.checked21',
  },
];

const EducationList = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="Vui lòng kiểm tra các mục bên dưới nếu bạn/gia đình của bạn được cung cấp thông tin hoặc hướng dẫn từ nhân viên bệnh viện để có thể hiểu đầy đủ hay chưa." />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={12}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default EducationList;
